import { FolderId } from 'modules/domains/foldering';
import { CampaignFolderActions } from 'modules/campaignIndex/campaignFolders/campaignFolderReducer';

// FETCH ROOT FOLDER INFORMATION (may differ by index)
export const fetchRootFolderIdResponse = (rootFolderId: FolderId) => ({
  type: CampaignFolderActions.fetchRootFolderId,
  rootFolderId,
});
